// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SettingsMenu from "@/components/settings/menu";
import * as Enums from '@/utils/enums';
import Router, {useRouter} from 'next/router';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import {Flex} from "@mantine/core";
import SettingsTriggerList from "@/PageComponents/Table/Component Tables/SettingsTriggerList";
import { createFileRoute } from '@tanstack/react-router'



const TriggerList = (props: any) => {

    const router = useRouter()

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };


    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    return (
        <div className="settings-container">
            <Flex>
                <SettingsMenu urlPath={router.asPath}/>
                <div className="settings-card">
                    <SettingsTriggerList />
                </div>
            </Flex>

        </div>
    );
};

export default TriggerList;

export const Route = createFileRoute('/_authenticated/settings/trigger/list')({ component: TriggerList })
